<template>
  <CBox class="audit-feedback-overlay">
    <CBox
      class="audit-feedback-sheet"
      :class="{
        'audit-feedback-sheet--cancellation': isCancellation,
        'audit-feedback-sheet--security': securityRecommendations,
        'audit-feedback-sheet--cancellation-notice': showCancellationNotice,
        'audit-feedback-sheet--analysis-protocol': showAnalysisProtocol
      }"
      role="dialog"
      aria-modal="true"
      aria-labelledby="audit-feedback-title"
    >
      <OmtButton
        class="audit-feedback-close"
        variant="ghost"
        height="32px"
        min-width="32px"
        p="0"
        aria-label="Fechar"
        @click="$emit('close')"
      >
        <OmtIcons
          name="xmark"
          size="lg"
        />
      </OmtButton>

      <OmtIcons
        class="audit-feedback-main-icon"
        v-bind="modalIconBind"
        size="3x"
      />

      <h1
        id="audit-feedback-title"
        class="audit-feedback-title"
      >
        {{ title }}
      </h1>

      <p
        v-if="description"
        class="audit-feedback-description"
      >
        {{ description }}
      </p>

      <CFlex
        v-if="showProtocol"
        class="audit-feedback-protocol"
        align="center"
      >
        <OmtIcons
          name="square-poll-horizontal"
          mr="16px"
        />
        <OmtTypography as="h2-bold"> Protocolo: {{ protocol }} </OmtTypography>
      </CFlex>

      <CBox
        v-if="cardTitle"
        class="audit-feedback-card"
      >
        <CFlex class="audit-feedback-card-title-row">
          <OmtIcons
            :name="cardIcon"
            class="audit-feedback-card-icon"
          />
          <OmtTypography
            as="h2-bold"
            class="audit-feedback-card-title"
          >
            {{ cardTitle }}
          </OmtTypography>
        </CFlex>
        <CBox
          class="audit-feedback-card-description"
          v-html="cardDescription"
        />
      </CBox>

      <OmtButton
        class="audit-feedback-button"
        fontSize="20px"
        fontWeight="700"
        lineHeight="24px"
        @click="$emit('buttonClick')"
      >
        {{ buttonLabel }}
      </OmtButton>
    </CBox>
  </CBox>
</template>

<script>
export default {
  props: {
    showCancellationNotice: Boolean,
    securityRecommendations: Boolean,
    showAnalysisProtocol: Boolean,
    buttonLabel: {
      type: String,
      default: "Continuar"
    },
    cardDescription: {
      type: String,
      default: ""
    },
    cardIcon: {
      type: String,
      default: "lock"
    },
    cardTitle: {
      type: String,
      default: ""
    },
    modalIconBind: {
      type: Object,
      default: () => ({ name: "clock", color: "var(--colors-light-primary-dark-blue)" })
    },
    protocol: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    isCancellation() {
      return this.title.includes("cancelada");
    },
    description() {
      if ((this.isCancellation && !this.showCancellationNotice) || this.showAnalysisProtocol) return "";
      return "Após a análise, você será notificado sobre os procedimentos necessários.";
    },
    showProtocol() {
      return (this.isCancellation || this.showAnalysisProtocol) && !!this.protocol;
    }
  }
};
</script>

<style scoped>
.audit-feedback-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  overflow-y: auto;
}

.audit-feedback-sheet {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  min-height: calc(100vh - 12px);
  display: flex;
  flex-direction: column;
  padding: 16px 16px 31px;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
}

.audit-feedback-close {
  align-self: flex-start;
  flex-shrink: 0;
}

.audit-feedback-main-icon {
  margin-top: 32px;
  flex-shrink: 0;
  width: 40px !important;
  height: 40px !important;
}

.audit-feedback-title {
  width: calc(100% - 4px);
  margin: 32px 0 0 4px;
  color: var(--colors-light-primary-gray1);
  font-family: "Open Sans", Roboto, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px !important;
}

.audit-feedback-description {
  width: 308px;
  max-width: calc(100% - 4px);
  margin: 11px 0 0 4px;
  color: var(--colors-light-primary-gray1);
  font-family: "Open Sans", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.audit-feedback-protocol {
  margin: 32px 0 0 5px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.audit-feedback-card {
  margin-top: 53px;
  width: 100%;
  min-height: 245px;
  padding: 17px 16px 10px;
  background: var(--colors-light-primary-light-gray);
  border-radius: 8px;
}

.audit-feedback-protocol + .audit-feedback-card {
  margin-top: 32px;
}

.audit-feedback-card-title-row {
  align-items: flex-start;
  width: 100%;
}

.audit-feedback-card-icon {
  flex: 0 0 16px;
  margin-top: 0;
  margin-right: 16px;
}

.audit-feedback-card-title {
  flex: 1;
  min-width: 0;
  line-height: 20px !important;
}

.audit-feedback-card-description {
  margin: 8px 0 0 3px;
  width: calc(100% - 3px);
  min-height: 170px;
  color: var(--colors-light-primary-gray1);
  font-family: "Open Sans", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.audit-feedback-button {
  width: 100%;
  flex-shrink: 0;
  margin-top: auto;
}

.audit-feedback-card {
  margin-bottom: 34px;
}

.audit-feedback-sheet--cancellation {
  padding-bottom: 21px;
}

.audit-feedback-sheet--analysis-protocol {
  padding-bottom: 23px;
}
.audit-feedback-sheet--analysis-protocol .audit-feedback-title {
  max-width: 287px;
  margin-top: 32px !important;
  line-height: 31px !important;
}
.audit-feedback-sheet--security .audit-feedback-card {
  min-height: 329px;
  padding-top: 13px;
  margin-bottom: 32px;
}
.audit-feedback-sheet--security .audit-feedback-card-description {
  margin-left: -7px;
  width: calc(100% + 7px);
  min-height: 0;
}
.audit-feedback-card-description::v-deep ul {
  display: block;
  margin: 0;
  padding-left: 20px;
  list-style: disc;
}
.audit-feedback-card-description::v-deep li + li {
  margin-top: 8px;
}
.audit-feedback-sheet--security .audit-feedback-title {
  margin-top: 32px !important;
  line-height: 31px !important;
}
.audit-feedback-sheet--cancellation-notice .audit-feedback-title {
  margin-top: 32px !important;
  line-height: 31px !important;
}
.audit-feedback-sheet--cancellation-notice .audit-feedback-description {
  margin-top: 19px;
}
.audit-feedback-sheet--cancellation-notice .audit-feedback-protocol {
  margin-top: 17px;
}
.audit-feedback-sheet--cancellation-notice .audit-feedback-card {
  margin-top: 19px;
}
@media screen and (min-width: 1024px) {
  .audit-feedback-sheet {
    top: 0;
    right: 0;
    left: auto;
    width: 420px;
    min-height: 100vh;
    border-radius: 0;
  }

  .audit-feedback-card-description {
    min-height: 0;
  }
}
</style>
